import { from as observableFrom, Observable } from 'rxjs'
import { map, take } from 'rxjs/operators'
import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router'

import { MatSnackBar } from '@angular/material/snack-bar';

import { ApiService,
         AuthService
        //  ToastService 
        } from 'src/app/_core/index'
        

@Injectable()
export class RoleGuard  {
  // constructor(private reflector: Reflector) {}
  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    private router: Router,
    private matSnackbar: MatSnackBar
    // private toast: ToastService
  ) {}

  matchRoles(roles: string[], userRole: string) {
    if (!roles) {
      console.log('ERR: RoleGuard !roles', roles)
      return true
    }
    return roles.some((role) => role === userRole);
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return observableFrom(this.authService.getCurrentUser().then(user => {
      if (!user) return this.handleLoggedOut(state)
      let roles = route.data.roles as Array<string>;
      // console.log('USER - CHECK ROLE', user, roles)
      if (this.matchRoles(roles, user.role)) return true
      return this.handleNotPermitted(state)
    }))
  }

  handleLoggedOut(state: any) {
    // this.toast.warning('You don\'t have access 😭', 'Not Permitted')
    // console.log('RoleGuard: REJECTED', state, )
    // this.apiService.updateReturnUrl(state.url)
    this.apiService.navigateToLoginPage({ returnPath: state.url })
    this.matSnackbar.open('LOGIN REQUIRED', 'close', { duration: 2000 });
    return false
  }

  handleNotPermitted(state: any) {
    // this.toast.warning('You don\'t have access 😭', 'Not Permitted')
    console.log('RoleGuard: NOT PERMITTED', state)
    this.matSnackbar.open('You don\'t have access 😭', 'bummer', { duration: 2000 });

    this.router.navigate(['/'])
    return false
  }

}